import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="profile-actions"
export default class extends Controller {
  static values = {
    summary: { type: String, default: "#profile-summary" },
    application: { type: String, default: "#profile-application" },
  }

  connect() {
    this.summary = document.querySelector(this.summaryValue)
    this.applicationSection = document.querySelector(this.applicationValue)
    if (!this.summary || !this.applicationSection) return

    this.handleViewportChange = this.handleViewportChange.bind(this)
    window.addEventListener("scroll", this.handleViewportChange, { passive: true })
    window.addEventListener("resize", this.handleViewportChange)
    this.refresh()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleViewportChange)
    window.removeEventListener("resize", this.handleViewportChange)
  }

  handleViewportChange() {
    this.refresh()
  }

  refresh() {
    this.summaryVisible = this.isVisible(this.summary)
    this.applicationVisible = this.isVisible(this.applicationSection)
    this.update()
  }

  isVisible(element) {
    const { bottom, top } = element.getBoundingClientRect()
    return bottom > 0 && top < window.innerHeight
  }

  update() {
    this.element.classList.toggle("hidden", this.summaryVisible || this.applicationVisible)
  }
}
